/*
* Customization for grouping_product_v2.html used for Europepiano product view
* It removes the plus minus buttons for the grouping component with name set in custom field with predefined alias value "gpcSingleMode"
* Many component names can be set by separating them with ';' in the custom field value
*/
((w: any) => {
    document.addEventListener("DOMContentLoaded", function (event) {
        var assetId = 'uc209-productview';

        if (w.umwAssets && w.umwAssets[assetId]) {
            w.umwAssets[assetId].forEach(function (ctx) {
                if (!ctx) return;

                var $mainPanel = document.querySelector(`#${ctx.uniqueId}`) as HTMLElement;
                if (!$mainPanel) return;
                
                const customFields = ctx.customFields as CustomField[] || [];
                const groupingComponents = ctx.groupingComponents as GroupingComponent[] || [];

                const cfGroupingComponentNames = (customFields.find(cf => cf.alias === 'gpcSingleMode')?.rawValue || '').split(';').map((name: string) => name.trim());

                $mainPanel.addEventListener('groupingproductprocessor:rendered', function (evt: CustomEvent) {
                    $mainPanel.querySelectorAll(`h2.grouping-component-title`).forEach(el => {
                        const groupingComponentName = el.textContent?.replace('*', '').trim() || '';
                        if(cfGroupingComponentNames.includes(groupingComponentName)){
                            const groupingComponent = groupingComponents.find(gc => gc.name === groupingComponentName);
                            if(groupingComponent.buyMode !== 0) return; // only process grouping components with buyMode = "One product must be selected"

                            const prent = el.closest('.grouping-component');
                            if (prent) {
                                _setupGroupingProductCustomization(prent as HTMLElement);
                            }
                        }
                    });
                });
            });
        }

        function _setupGroupingProductCustomization(groupingComponentContainer: HTMLElement) {
            groupingComponentContainer.classList.add('grouping-component-js-customization');
            groupingComponentContainer.querySelectorAll('.js-quantity').forEach(input => {
                (input as HTMLInputElement).readOnly = true;
            });

            groupingComponentContainer.querySelectorAll('.js-plus-minus-container-grouping-product button')
                .forEach(button => button.remove());

            groupingComponentContainer.querySelectorAll('.grouping-product-prices').forEach(el => el.remove());

            groupingComponentContainer.addEventListener('click', function(evt){
                const target = evt.target as HTMLElement;
                const productContainer = target.closest('.grouping-product') as HTMLElement;
                if (!productContainer) return;
                const quantityInput = productContainer.querySelector('.js-quantity') as HTMLInputElement;
                if (quantityInput) {
                    _setQuantityForAllComponentProducts(groupingComponentContainer, 0);
                    _setQuantity(quantityInput, 1);
                }
            });
        }

        function _setQuantity(quantityInput: HTMLInputElement, value: number) {
            quantityInput.value = String(value);
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function _setQuantityForAllComponentProducts(groupingComponentContainer: HTMLElement, value: number) {
            groupingComponentContainer.querySelectorAll('.grouping-product').forEach(productContainer => {
                const quantityInput = productContainer.querySelector('.js-quantity') as HTMLInputElement;
                if (quantityInput) {
                    quantityInput.value = String(value); // set silently — no change event, avoids triggering _toggleProductSelected
                }
            });
        }
        
    
    });
})(window as any);


interface GroupingComponent{
    "uniqueId": string,
    "name": string,
    "orderNo": number,
    "buyMode": number,
    "variantProductViewType": number,
    "componentViewType": number,
    "componentProducts": any[]
}

interface CustomField{
    "id": number,
    "alias": string,
    "rawValue": string,
    "value": string
}